import styled from 'styled-components'
import { colors, media } from 'client/styles'
import { RoomInformationBase } from 'src/comps/RoomInformation/styles'

export const SelectOfferBase = styled.div`
  background-color: ${colors.grey5};
  width: 100%;
  overflow-y: hidden;
  height: auto;

  ${media.tablet} {
    height: calc(80vh);
    overflow-y: scroll;
  }
`

export const Header = styled.div`
  background-color: ${colors.white};
  width: 100%;
  padding-block: 0 var(--space-20);
  padding-inline: var(--space-20);

  ${media.tablet} {
    padding-block-start: var(--space-0);
  }
`

export const Row = styled.div`
  display: flex;
  width: 100%;
  padding-block: var(--space-16);
  padding-inline: var(--space-0);
`

export const Title = styled(Row)`
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
  color: ${colors.grey1};
  padding-block: 0 var(--space-16);
  padding-inline: 0;

  ${media.tablet} {
    padding-inline: 0;
  }
`

export const Text = styled(Row)`
  display: flex;
  font-weight: 500;
  font-size: var(--font-size-1);
  line-height: 100%;
  color: ${colors.grey2};
  padding-block-end: var(--space-10);

  ${media.tablet} {
    height: 28px;
    padding-block: 0;
    padding-inline: 0;
  }
`

export const BoardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  gap: var(--space-16);

  padding-block: var(--space-16);
  padding-inline: var(--space-20);
  ${RoomInformationBase} {
    margin-block: var(--space-16);
    margin-inline: 0;
  }
`

export const DatesDetailsWrapper = styled.div`
  display: flex;
  flex-flow: column;
  gap: var(--space-8);
  align-items: center;

  & > div {
    border: var(--border-size-2) solid var(--color-neutral-400);
    border-radius: var(--radius-8);
    width: 100%;
    padding: var(--space-16);
  }

  ${media.tablet} {
    flex-flow: row;
    align-items: normal;
    gap: var(--space-4);

    & > svg {
      align-self: center;
      width: var(--size-48);
      height: var(--size-48);
      transform: rotate(270deg);
    }
  }
`
